import api from './data.services'

const registerSrv = 'audit/patient/register'

interface PatientRegister {
  status: string
  document_type_id: number
  document_number: string
  email: string
  cellphone: string
}
interface PatientUpdate {
  status: string
  document_type_id: number
  document_number: string
}

const savePatientRegister = async (patientRegister: PatientRegister) => {
  try {
    const resp: any = await api.post(
      registerSrv,
      patientRegister
    )

    return {
      status: 'Ok',
      data: (resp && resp.data ? resp.data : {})
    }
  } catch(error) {
    return {
      status: 'Error',
      data: {},
      message: 'Error server al guardar auditoria de registro de paciente!'
    }
  }
}

const updatePatienteRegister = async (PatientUpdate: PatientUpdate) => {
  try {
    const resp: any = await api.put(
      registerSrv,
        PatientUpdate
    )

    return {
      status: 'Ok',
      data: (resp && resp.data ? resp.data : {})
    }
  } catch(error) {
    return {
      status: 'Error',
      data: {},
      message: 'Error server al actualizar auditoria de registro de paciente!'
    }
  }
}

export const auditService = {
  savePatientRegister,
  updatePatienteRegister
}